export class Usuario {
    email:string;
    nombre:string;
    idioma:string;
    numeroPersonaFrontera:string;
    nombrePosicion:string;
    pais:string;
    vicepresidencia:string;
    emailJefe:string;
    lugar:string;
    area:string;
    direccionGerencia;
    super_admin;
    estado:string;
}
